import "core-js/modules/es6.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-lg-4 footer--socialLinks"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('footer.social_follow_us')))]), _vm._v(" "), _c('ul', _vm._l(_vm.content.social_links, function (link) {
    return _c('li', {
      key: link.name,
      class: "footer--social-".concat(link.name)
    }, [_c('MdmLink', {
      attrs: {
        "url": link.url,
        "is-scramble-link": _vm.isScrambleLink,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('mdm-icon', {
      class: "icon icon-item social-".concat(link.name),
      attrs: {
        "original": true,
        "name": "".concat(link.name)
      }
    })], 1)], 1);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };